@if (agent()) {
  <!-- Sticky top-panel: хлебные крошки + section-nav — один блок,
       который при скролле липнет как единое целое. Никаких sticky-в-sticky
       с magic-числами top. -->
  <div class="agent-top-panel">
    <div class="top-panel-container">
      <!-- Left Section -->
      <div class="panel-left-section">
        <!-- Breadcrumbs -->
        <p-breadcrumb [model]="breadcrumbItems" styleClass="custom-breadcrumb compact-breadcrumb"
        [style]="{'--p-breadcrumb-padding': '0', '--p-breadcrumb-item-hover-color': 'var(--p-primary-color)'}"></p-breadcrumb>
      </div>
      <!-- Right Section -->
      <div class="panel-right-section">
        <p-button
          #menuButton
          icon="pi pi-ellipsis-h"
          severity="secondary"
          [outlined]="true"
          size="small"
          (click)="agentMenu.toggle($event); $event.stopPropagation()">
        </p-button>
        <p-menu
          #agentMenu
          [model]="agentMenuItems"
          [popup]="true"
          [appendTo]="'body'"
          styleClass="custom-agent-menu">
        </p-menu>
      </div>
    </div>
    <!-- p-tabs как чистая полоса-навигация: НЕТ <p-tabpanels> — секции
         живут отдельно в DOM (одна длинная страница). currentSection()
         обновляется IntersectionObserver'ом при скролле, PrimeNG сам
         подсвечивает соответствующий таб. Клик по табу → onTabsClick() →
         setActiveTab (tests/talk) или scrollIntoView (settings-секция). -->
    <!-- Кастомизация PrimeNG-табов: почему именно [dt], а не что-то другое.
         Каждый вариант я честно попробовал:
           1) `:host ::ng-deep .p-tablist { background: transparent }` —
              каскад не пробивает, потому что PrimeNG рисует preset поверх
              и специфичность/порядок не в мою пользу.
           2) Глобальный styles.css с !important — работает, но грязно:
              полосы будут кастомными на всех страницах, а тема должна
              оставаться темой.
           3) [dt]="{ 'tabs.tablist.background': 'transparent' }" —
              выглядит логично, но PrimeNG САМ оборачивает переданный
              object в `{ tabs: ... }` (имя компонента становится корневым
              ключом внутри `_toVariables`). В итоге ключи превращаются
              в `{ tabs: { tabs: { tablist: {...} } } }` → CSS-переменная
              `--p-tabs-tabs-tablist-background` (двойной префикс), а
              компонент читает `--p-tabs-tablist-background` — облом.
         Правильно: ключи в [dt] пишем БЕЗ префикса имени компонента, как
         под-token'ы. PrimeNG сам добавит `tabs.` сверху. Так token'ы
         разрешаются в те же переменные, которые компонент реально читает. -->
    <p-tabs [value]="tabsValue()" (valueChange)="onTabsClick($event)"
            class="agent-tabs" [scrollable]="true"
            [dt]="{
              tablist: { background: 'transparent' },
              tab: { padding: '0.4rem 0.9rem' }
            }">
      <p-tablist #agentTabList class="agent-tablist">
        <p-tab value="sec-agent"       i18n="@@agentEdit.tab.agent">Agent</p-tab>
        @if (!isRealtimeMode()) {
          <p-tab value="sec-voice"       i18n="@@agentEdit.tab.voice">Voice</p-tab>
          <p-tab value="sec-transcriber" i18n="@@agentEdit.tab.transcriber">Transcriber</p-tab>
          <p-tab value="sec-vad"         i18n="@@agentEdit.tab.voiceAutoDetection">Voice auto detection</p-tab>
        }
        <p-tab value="sec-widget"      i18n="@@agentEdit.tab.widget">Widget</p-tab>
        <p-tab value="tests"           i18n="@@agentEdit.tab.tests">Tests</p-tab>
        <p-tab value="talk"            i18n="@@agentEdit.tab.talkToAgent">Talk to agent</p-tab>
      </p-tablist>
    </p-tabs>
  </div>
}
<!-- Поверхность встроенного агента: всё, что внутри и умеет редактироваться
     (ngModel), он видит и может предложить изменить — списка полей в коде
     нет, директива snAssistantEditable собирает их сама. -->
<div class="agent-edit-container"
     snAssistantSurface="agent"
     i18n-surfaceTitle="@@agentEdit.surface"
     surfaceTitle="Agent editor"
     [surfaceReveal]="revealAgentField">
  @if (agent()) {
    <div>

      @if (activeTabIndex() === 'tests') {
        <div class="form-container">
          @if (agent()!.id; as agentId) {
            <app-agent-tests-tab [agentId]="agentId"></app-agent-tests-tab>
          }
        </div>
      } @else if (activeTabIndex() === 'talk') {
        <!-- Talk mode — тестер сам занимает max-height: 80vh; никаких legacy
             .form-container с фиксированной шириной 800px и padding-bottom 100px:
             это создавало вертикальный скролл. Просто центрируем компонент. -->
        <div class="talk-container">
          @if (agent()!.id; as agentId) {
            <!-- Встроенный тестер. publicAgentOverride передаёт live: список
                 языков + publish_options — без save. widgetMode=false:
                 показываем full-layout как в /agents/:id/test.
                 showTranslatePicker=false: язык админки управляется глобально.
                 first_message / LLM / STT / TTS / инструкции — на бэке при
                 dispatch'е, для их применения нужен Save. -->
            <app-agent-test
              [agentId]="agentId"
              [publicAgentOverride]="publicAgentPreview()"
              [widgetMode]="false"
              [showTranslatePicker]="false">
            </app-agent-test>
          }
        </div>
      } @else {
        <section id="sec-agent">
            <div class="form-container">
              <!-- Mode Selector: Classic (STT→LLM→TTS) vs Realtime (voice-to-voice). -->
              <div class="form-field agent-mode-field">
                <label class="field-label" i18n="@@agentEdit.mode.label">Working Mode</label>
                <p class="field-description" i18n="@@agentEdit.mode.description">
                  Classic — a traditional STT→LLM→TTS pipeline with independent models per stage. Realtime — a single voice-to-voice model (OpenAI Realtime, etc.).
                </p>
                <p-selectButton
                 
                  [snAssistantId]="F.mode"
                  snAssistantOptions="Classic,Realtime"
                  [options]="agentModeOptions"
                  [ngModel]="agent()!.mode ?? 'Classic'"
                  (ngModelChange)="onAgentModeChange($event)"
                  optionLabel="label"
                  optionValue="value"
                  [allowEmpty]="false">
                </p-selectButton>
              </div>
              <!-- Agent Name Section -->
              <div class="form-field">
                <label for="agentName" class="field-label" i18n="@@agentEdit.name.label">Agent Name</label>
                <p class="field-description" i18n="@@agentEdit.name.description">The name of your agent.</p>
                <input
                  pInputText
                  inputId="agentName"
                 
                  [snAssistantId]="F.title"
                  [(ngModel)]="agent()!.title"
                  (ngModelChange)="onNameChange($event)"
                  i18n-placeholder="@@agentCreate.name.placeholder"
                  placeholder="Enter agent name"
                  class="w-full"
                  styleClass="w-full">
              </div>
              <!-- Agent Languages Section -->
              <div class="form-field">
                <label class="field-label" i18n="@@agentEdit.languages.label">Agent Languages</label>
                <p class="field-description" i18n="@@agentEdit.languages.description">Configure languages and first messages for your agent.</p>
                <!-- Language Locales Cards -->
                @if (agent()!.language_locales?.length) {
                  @for (locale of agent()!.language_locales; track $index) {
                    <p-card class="language-locale-card">
                      <div class="language-locale-header">
                        <h4 class="locale-title">
                          @if (locale.is_default) {
                            <ng-container i18n="@@agentEdit.language.default">Default Language</ng-container>
                          } @else {
                            <ng-container i18n="@@agentEdit.language.additional">Additional Language</ng-container>
                          }
                        </h4>
                        @if (!locale.is_default) {
                          <p-button
                            type="button"
                            icon="pi pi-trash"
                            severity="danger"
                            [text]="true"
                            size="small"
                            (click)="removeLanguageLocale($index)"
                            class="remove-language-btn">
                          </p-button>
                        }
                      </div>
                      <div class="locale-content">
                        <!-- Language Selection -->
                        <div class="locale-field">
                          <p class="locale-field-description">
                            @if (locale.is_default) {
                              <ng-container i18n="@@agentEdit.language.default.desc">Choose the default language the agent will communicate in.</ng-container>
                            } @else {
                              <ng-container i18n="@@agentEdit.language.additional.desc">Specify additional language the agent will communicate in.</ng-container>
                            }
                          </p>
                          <p-select
                            [options]="getLanguageOptionsForLocale(locale)"
                            [ngModel]="getLanguageCodeForLocale(locale)"
                            (ngModelChange)="onLocaleLanguageChange($index, $event)"
                            optionLabel="label"
                            optionValue="value"
                            i18n-placeholder="@@agentEdit.language.select"
                            placeholder="Select language"
                            styleClass="w-full">
                          </p-select>
                        </div>
                        <!-- First Message -->
                        <div class="locale-field">
                          <label class="locale-field-label" i18n="@@agentEdit.firstMessage.label">First Message</label>
                          <p class="locale-field-description" i18n="@@agentEdit.firstMessage.description">The first message the agent will say. If empty, the agent will wait for the user to start the conversation.</p>
                          <textarea
                            pTextarea
                            variableScope="agent"
                            [snAssistantId]="'firstMessage.' + $index"
                            [appVariableTracker]="'first-message-' + $index"
                            [variableAgentTitle]="agent()?.title ?? null"
                            [text]="locale.first_message || ''"
                            [(ngModel)]="locale.first_message"
                            [(variablesSchema)]="agent()!.variables_open_api_schema"
                            [placeholder]="getDefaultFirstMessageForLocale(locale)"
                            styleClass="w-full"
                            rows="3">
                          </textarea>
                        </div>
                      </div>
                    </p-card>
                  }
                }
                <!-- Add Language Button -->
                <div class="add-language-section">
                  <p-button
                    type="button"
                    i18n-label="@@agentEdit.language.add"
                    label="Add Language"
                    icon="pi pi-plus"
                    severity="secondary"
                    [outlined]="true"
                    size="small"
                    [disabled]="availableLanguagesMenuItems.length === 0"
                    (click)="addLanguageMenu.toggle($event)">
                  </p-button>
                  <p-menu
                    #addLanguageMenu
                    [model]="availableLanguagesMenuItems"
                    [popup]="true"
                    [appendTo]="'body'">
                  </p-menu>
                </div>
              </div>
              <!-- Disable Interruptions Section -->
              <div class="form-field">
                <div class="switch-field">
                  <div class="switch-content">
                    <label class="switch-label" i18n="@@agentEdit.disableInterruptions.label">Disable interruptions during first message</label>
                    <p class="field-description" i18n="@@agentEdit.disableInterruptions.description">Select this box to prevent users from interrupting while the first message is being delivered.</p>
                  </div>
                  <p-toggleSwitch
                   
                    [snAssistantId]="F.disableInterruptions"
                    [(ngModel)]="agent()!.disable_interruptions_during_first_message">
                  </p-toggleSwitch>
                </div>
              </div>
              <!-- System Prompt Section -->
              <div class="form-field">
                <div class="system-prompt-header">
                  <label for="systemPrompt" class="field-label" i18n="@@agentEdit.systemPrompt.label">System prompt</label>
                </div>
                <p class="field-description" i18n="@@agentEdit.systemPrompt.description">The system prompt is used to determine the persona of the agent and the context of the conversation.</p>
                <a href="#" class="learn-more-link" i18n="@@common.learnMore">Learn more</a>
                @if (primaryLanguageLocaleOptions.length > 0) {
                  <div class="system-prompt-options">
                    <label for="systemPromptOption" class="field-label" i18n="@@agentEdit.systemPrompt.template.label">Load from template</label>
                    <p-select
                      [snAssistantId]="F.systemPromptOption"
                      inputId="systemPromptOption"
                      [options]="primaryLanguageLocaleOptions"
                      [(ngModel)]="selectedSystemPromptOption"
                      (ngModelChange)="onSystemPromptOptionSelect($event)"
                      optionLabel="label"
                      optionValue="value"
                      i18n-placeholder="@@agentEdit.systemPrompt.template.placeholder"
                      placeholder="Select a template option"
                      [showClear]="true"
                      styleClass="w-full">
                    </p-select>
                  </div>
                }
                <textarea
                  pTextarea
                  inputId="systemPrompt"
                 
                  [snAssistantId]="F.systemPrompt"
                  variableScope="agent"
                  appVariableTracker="system-prompt"
                  [variableAgentTitle]="agent()?.title ?? null"
                  [text]="agent()!.system_prompt || ''"
                  [autoResize]="true"
                  [(ngModel)]="agent()!.system_prompt"
                  [(variablesSchema)]="agent()!.variables_open_api_schema"
                  i18n-placeholder="@@agentEdit.systemPrompt.placeholder"
                  placeholder="Describe the desired agent (e.g., a customer support agent for ElevenLabs)"
                  class="system-prompt-textarea">
                </textarea>
              </div>
              <!-- Model Chain Section — единый блок. В Cascade это каскад
                   LLM-моделей (agent.model_versions, type=llm) без деления на
                   основную и fallback: порядок в списке = порядок перебора.
                   В Realtime — одна voice-to-voice модель. Все привязки идут
                   через `active*()` signal computed'ы. -->
              <div class="form-field">
                @if (isRealtimeMode()) {
                  <label class="field-label" i18n="@@agentEdit.realtime.label">Realtime Model</label>
                  <p class="field-description" i18n="@@agentEdit.realtime.description">Voice-to-voice модель обработает вход, размышления и синтез аудио в одной wire-сессии. Голос выбирается для каждого языка ниже.</p>
                  <!-- Realtime: модель одна, каскад не применяется. -->
                  <div class="model-selection" style="width: 100%">
                    <label class="sub-field-label" i18n="@@agentEdit.llm.modelVersion">Model Version</label>
                    <app-model-selector-button
                      snAssistantAnchor="modelVersion"
                      [modelTypes]="activeModelTypes()"
                      [modelsHierarchy]="modelsHierarchy"
                      [includeVersionSnapshots]="activeChainSnapshots()"
                      [selectedVersionId]="activePrimaryVersionId()"
                      [savedModel]="activePrimarySnapshot()"
                      [allowModelSelect]="true"
                      [showVersions]="false"
                      [allowSelectFromTester]="true"
                      [currentAdditionalProperties]="getActiveRowAdditionalValuesDict(0)"
                      [currentTemperature]="activePrimaryTemperature()"
                      [currentTopP]="activePrimaryTopP()"
                      [currentTopK]="activePrimaryTopK()"
                      [currentMaxOutputTokens]="activePrimaryMaxOutputTokens()"
                      [currentVoiceId]="activePrimaryVoiceId()"
                      [customLlmGatewayCodes]="[]"
                      [currentCustomHeadersSchema]="null"
                      [currentCustomBodySchema]="null"
                      [includeAll]="modelsIncludeAll"
                      (includeAllChange)="onModelsIncludeAllChange($event)"
                      [excludeVersionIds]="[]"
                      [label]="selectRealtimeModelLabel"
                      (modelSelected)="onActiveRowModelSelected(0, $event)"
                      (testerSelected)="onActiveRowTesterSelected(0, $event)">
                    </app-model-selector-button>
                  </div>
                } @else {
                  <label for="llmModel" class="field-label" i18n="@@agentEdit.llm.cascade.label">LLM model cascade</label>
                  <p class="field-description" i18n="@@agentEdit.llm.cascade.description">
                    The agent walks the list top to bottom: it takes the first available model and falls through to the next one when a model doesn't answer. Order matters — drag rows by the handle on the left to change the priority.
                  </p>
                  <p class="field-description llm-docs-link">
                    <ng-container i18n="@@agentEdit.llm.docs.before">Not sure which model to pick? </ng-container>
                    <a [href]="llmDocsUrl" target="_blank" rel="noopener"
                       class="learn-more-link" i18n="@@agentEdit.llm.docs.link">
                      Read about supported LLMs and how they perform
                    </a>
                    <ng-container i18n="@@agentEdit.llm.docs.after2"> — same page covers the model cascade and temperature.</ng-container>
                  </p>
                  <div class="llm-cascade-section">
                    @for (row of activeCascadeRows(); track $index; let i = $index) {
                      <div class="llm-cascade-row"
                        pDraggable="llmCascade"
                        dragHandle=".llm-cascade-handle"
                        pDroppable="llmCascade"
                        (onDragStart)="onActiveRowDragStart(i)"
                        (onDragEnd)="onActiveRowDragEnd()"
                        (onDrop)="onActiveRowDrop(i)">
                        <i class="pi pi-bars llm-cascade-handle"></i>
                        <span class="llm-cascade-index">{{ i + 1 }}</span>
                        <div class="llm-cascade-picker">
                          <app-model-selector-button
                            [snAssistantAnchor]="i === 0 ? 'modelVersion' : ''"
                            [modelTypes]="activeModelTypes()"
                            [modelsHierarchy]="modelsHierarchy"
                            [includeVersionSnapshots]="activeChainSnapshots()"
                            [selectedVersionId]="row.model_version_id || undefined"
                            [savedModel]="getActiveRowSavedModel(i)"
                            [allowModelSelect]="true"
                            [showVersions]="false"
                            [allowSelectFromTester]="true"
                            [currentAdditionalProperties]="getActiveRowAdditionalValuesDict(i)"
                            [currentTemperature]="getActiveRowTemperature(i)"
                            [currentTopP]="getActiveRowTopP(i)"
                            [currentTopK]="getActiveRowTopK(i)"
                            [currentMaxOutputTokens]="getActiveRowMaxOutputTokens(i)"
                            [customLlmGatewayCodes]="customLlmGatewayCodes"
                            [currentCustomHeadersSchema]="getLlmRowCustomHeadersSchema(i)"
                            [currentCustomBodySchema]="getLlmRowCustomBodySchema(i)"
                            [includeAll]="modelsIncludeAll"
                            (includeAllChange)="onModelsIncludeAllChange($event)"
                            [excludeVersionIds]="activeRowExcludeIds(i)"
                            [label]="selectLlmModelLabel"
                            (modelSelected)="onActiveRowModelSelected(i, $event)"
                            (testerSelected)="onActiveRowTesterSelected(i, $event)">
                          </app-model-selector-button>
                        </div>
                        @if (canRemoveActiveRow()) {
                          <p-button
                            icon="pi pi-times"
                            severity="danger"
                            [text]="true"
                            [rounded]="true"
                            (click)="removeActiveRow(i)"
                            i18n-pTooltip="@@agentEdit.llm.cascade.remove"
                            pTooltip="Remove model from the cascade"
                            tooltipPosition="top"
                            i18n-ariaLabel="@@agentEdit.llm.cascade.remove"
                            ariaLabel="Remove model from the cascade">
                          </p-button>
                        }
                      </div>
                    }
                    @if (canAddActiveRow()) {
                      <p-button
                        icon="pi pi-plus"
                        severity="secondary"
                        [outlined]="true"
                        size="small"
                        (click)="addActiveRow()"
                        i18n-label="@@agentEdit.llm.cascade.add"
                        label="Add model">
                      </p-button>
                    }
                  </div>
                }
                <!-- Ни Temperature, ни Max Output Tokens больше не редактируются
                     на уровне агента: и то, и другое живёт per-LLM (каждый
                     picker внутри llm_versions ряда имеет свой слайдер +
                     disable toggle). Legacy agent.limit_token_usage — dead. -->

                <!-- Agent Knowledge Base Section (Disabled) -->
                <!-- <div class="parameter-field">
                <label class="sub-field-label">Agent Knowledge Base</label>
                <p class="parameter-description">Upload documents and data sources for the agent to reference. (Coming Soon)</p>
                <div class="knowledge-base-placeholder disabled">
                  <div class="placeholder-content">
                    <i class="pi pi-file-plus"></i>
                    <div>Knowledge base feature coming soon</div>
                  </div>
                </div>
              </div> -->
            </div>
            <!-- STT Section - Temporarily disabled until new API is ready -->
            <!-- <div class="form-field">
            <label for="sttProvider" class="field-label">Speech To Text (STT)</label>
            <p class="field-description">Choose the Speech-to-Text provider and specific model to use for this agent()!.</p>
            <div class="stt-selection">
              <div class="provider-field">
                <label for="sttProvider" class="sub-field-label">Provider</label>
                <p-select
                  [snAssistantId]="F.sttProvider"
                  inputId="sttProvider"
                  [options]="sttProviderOptions"
                  [(ngModel)]="selectedSttProvider"
                  (ngModelChange)="onSttProviderChange()"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Select STT provider"
                  styleClass="w-full">
                </p-select>
              </div>
              <div class="model-field">
                <label for="sttModel" class="sub-field-label">Model</label>
                <p-select
                  [snAssistantId]="F.sttModel"
                  inputId="sttModel"
                  [options]="sttModelOptions"
                  [(ngModel)]="selectedSttModel"
                  (ngModelChange)="onSttModelChange()"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Select model"
                  [disabled]="!selectedSttProvider"
                  styleClass="w-full">
                </p-select>
              </div>
            </div>
          </div> -->
          <!-- Tools Section -->
          <div class="form-field">
            <label class="field-label" i18n="@@agentEdit.tools.label">Tools</label>
            <p class="field-description" i18n="@@agentEdit.tools.description">Configure default and custom tools available to the agent during conversations.</p>
            <!-- Default Tools -->
            <!-- <div class="tools-subsection">
            <label class="sub-field-label">Default Tools</label>
            <div class="default-tools-list">
              <div class="tool-item">
                <div class="tool-content">
                  <i [class]="defaultTools.endCall.icon + ' tool-icon'"></i>
                  <span>{{ defaultTools.endCall.label }}</span>
                </div>
                <p-toggleswitch
                 
                  [snAssistantId]="F['defaultTool.endCall']"
                  [(ngModel)]="defaultTools.endCall.enabled"
                  (ngModelChange)="onDefaultToolToggle('endCall', $event)">
                </p-toggleswitch>
              </div>
              <div class="tool-item">
                <div class="tool-content">
                  <i [class]="defaultTools.transferToAgent.icon + ' tool-icon'"></i>
                  <span>{{ defaultTools.transferToAgent.label }}</span>
                </div>
                <p-toggleswitch
                 
                  [snAssistantId]="F['defaultTool.transferToAgent']"
                  [(ngModel)]="defaultTools.transferToAgent.enabled"
                  (ngModelChange)="onDefaultToolToggle('transferToAgent', $event)">
                </p-toggleswitch>
              </div>
            </div>
          </div> -->
          <!-- System Tools -->
          <div class="tools-subsection">
            <label class="sub-field-label" i18n="@@agentEdit.tools.system">System Tools</label>
            @if (systemTools().length > 0) {
              <div class="system-tools-list">
                @for (entry of systemTools(); track entry.tool.id) {
                  <div class="tool-item">
                    <div class="tool-content">
                      <i class="pi pi-cog tool-icon"></i>
                      <div class="tool-details">
                        <span class="tool-name">
                          {{ entry.title }}
                          @if (entry.tool.is_empty) {
                            <p-tag [value]="placeholderTagLabel" severity="secondary" [rounded]="true" [pTooltip]="placeholderTooltip" tooltipPosition="top" class="empty-tool-tag"></p-tag>
                          }
                        </span>
                        @if (entry.summary) {
                          <span class="tool-summary">{{ entry.summary }}</span>
                        }
                      </div>
                      <div class="tool-controls">
                        @if (isSystemToolEnabled(entry.tool.id || '')) {
                          <p-button
                            type="button"
                            icon="pi pi-cog"
                            [text]="true"
                            severity="secondary"
                            size="small"
                            class="settings-button"
                            (click)="editSystemTool(entry.tool); $event.stopPropagation()">
                          </p-button>
                        }
                        <!-- Каждый системный инструмент — отдельное поле для
                             агента: id по коду инструмента, подпись и описание
                             те же, что видит пользователь. -->
                        <p-toggleswitch
                          [snAssistantId]="'tool.' + entry.tool.code"
                          [snAssistantLabel]="entry.title"
                          [snAssistantHint]="entry.summary"
                          [ngModel]="isSystemToolEnabled(entry.tool.id || '')"
                          (ngModelChange)="onSystemToolToggle(entry.tool.id || '', $event)"
                          [disabled]="isSystemToolDisabled(entry.tool.code)">
                        </p-toggleswitch>
                      </div>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <p class="empty-tools-message" i18n="@@agentEdit.tools.system.empty">No system tools available</p>
            }
          </div>
          <!-- Webhook Tools -->
          <div class="tools-subsection">
            <label class="sub-field-label" i18n="@@agentEdit.tools.webhook">Webhook Tools</label>
            <!-- Connected Webhook Tools List -->
            @if (connectedWebhookTools().length > 0) {
              <div class="connected-tools-list">
                @for (tool of connectedWebhookTools(); track tool.id) {
                  <div class="connected-tool-item" (click)="editTool(tool.id || '')">
                    <div class="tool-info">
                      <i class="pi pi-link tool-icon"></i>
                      <div class="tool-details">
                        <span class="tool-name">
                          {{ tool.title }}
                          @if (getAgentTool(tool.id || '')?.async) {
                            <i
                              class="pi pi-bolt async-badge"
                              i18n-pTooltip="@@agentEdit.tools.async.tooltip"
                              pTooltip="Асинхронный вызов: агент не ждёт ответ инструмента, диалог продолжается, а результат подмешается, когда придёт."
                              tooltipPosition="top">
                            </i>
                          }
                        </span>
                        @if (tool.description) {
                          <span class="tool-description">{{ tool.description }}</span>
                        }
                      </div>
                    </div>
                    <div class="tool-actions">
                      <p-button
                        type="button"
                        icon="pi pi-trash"
                        severity="danger"
                        [outlined]="true"
                        size="small"
                        (click)="removeToolFromAgent(tool.id || ''); $event.stopPropagation()">
                      </p-button>
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Webhook Tools List -->
            <!-- <div class="webhook-tools-list" *ngIf="webhookTools.length > 0">
            <div class="webhook-tool-item"
              *ngFor="let tool of webhookTools"
              (click)="editWebhookTool(tool)">
              <div class="tool-info">
                <i class="pi pi-link tool-icon"></i>
                <div class="tool-details">
                  <span class="tool-name">{{ tool.name }}</span>
                  <span class="tool-type">{{ tool.method || 'POST' }} • {{ tool.endpoint }}</span>
                </div>
              </div>
              <div class="tool-actions">
                <p-button
                  type="button"
                  icon="pi pi-pencil"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  (click)="editWebhookTool(tool); $event.stopPropagation()">
                </p-button>
                <p-button
                  type="button"
                  icon="pi pi-trash"
                  severity="danger"
                  [outlined]="true"
                  size="small"
                  (click)="deleteWebhookTool(tool); $event.stopPropagation()">
                </p-button>
              </div>
            </div>
          </div> -->
          <div class="custom-tools-container">
            <p-button
              #customToolsButton
              i18n-label="@@agentEdit.tools.add"
              label="Add tool"
              icon="pi pi-plus"
              severity="secondary"
              [outlined]="true"
              size="small"
              (click)="customToolsMenu.toggle($event); $event.stopPropagation()">
            </p-button>
            <p-menu
              #customToolsMenu
              [model]="customToolsMenuItems"
              [popup]="true"
              [appendTo]="'body'"
              styleClass="custom-tools-menu">
            </p-menu>
          </div>
        </div>
      </div>
    </div>
        </section>
        <section id="sec-voice" [hidden]="isRealtimeMode()">
    <div class="form-container">
      <!-- Voice Settings Section — Cascade: TTS модель + голос per-locale.
           Realtime: модель одна (в sec-agent), тут только голос per-locale. -->
      <div class="form-field">
        <label class="field-label" i18n="@@agentEdit.voice.label">Voice Configuration</label>
        @if (isRealtimeMode()) {
          <p class="field-description" i18n="@@agentEdit.voice.description.realtime">Настройте голос для каждого языка. Модель одна на весь агент — выбрана в разделе «Agent».</p>
        } @else {
          <p class="field-description" i18n="@@agentEdit.voice.description">Configure text-to-speech models for each language your agent supports.</p>
        }
        <!-- TTS Model Cards -->
        @if (agent()!.language_locales?.length) {
          @for (locale of agent()!.language_locales; track $index) {
            <p-card class="language-locale-card">
              <div class="language-locale-header">
                <h4 class="locale-title">
                  @if (locale.is_default) {
                    Default Language
                  } @else {
                    Additional Language
                  }
                </h4>
                <!-- No delete button for Voice section -->
              </div>
              <div class="locale-content">
                <!-- Language Display (read-only) -->
                <div class="locale-field">
                  <label class="locale-field-label" i18n="@@agentEdit.voice.language.label">Language</label>
                  <p class="locale-field-description">
                    @if (locale.is_default) {
                      <ng-container i18n="@@agentEdit.voice.language.default.desc">The default language for text-to-speech output.</ng-container>
                    } @else {
                      <ng-container i18n="@@agentEdit.voice.language.additional.desc">Additional language for text-to-speech output.</ng-container>
                    }
                  </p>
                  <input
                    pInputText
                    [value]="getLanguageDisplayName(getLanguageCodeForLocale(locale) || '')"
                    readonly
                    class="readonly-language-input"
                    styleClass="w-full">
                </div>
                <!-- Voice / TTS Selection. В Realtime модель одна на весь
                     агент (activePrimaryVersionId из sec-agent), тут через
                     тестер выбирается только голос — disableModelSelection
                     пропускает экран выбора модели, сразу открывается tester
                     с прешедшей моделью. В Cascade — обычный TTS-picker. -->
                <div class="locale-field">
                  @if (isRealtimeMode()) {
                    <label class="locale-field-label" i18n="@@agentEdit.realtime.voice.label">Голос</label>
                    <p class="locale-field-description" i18n="@@agentEdit.realtime.voice.description">Выберите голос из Realtime-модели агента.</p>
                  } @else {
                    <label class="locale-field-label" i18n="@@agentEdit.tts.label">TTS Model</label>
                    <p class="locale-field-description" i18n="@@agentEdit.tts.description">Select the text-to-speech model for this language.</p>
                  }
                  <app-model-selector-button
                    [disableModelSelection]="isRealtimeMode()"
                    [modelTypes]="isRealtimeMode() ? ['realtime'] : ['tts']"
                    [modelsHierarchy]="modelsHierarchy"
                    [includeVersionSnapshots]="isRealtimeMode() ? activeChainSnapshots() : ttsSnapshotsForLocale(locale)"
                    [selectedVersionId]="isRealtimeMode() ? activePrimaryVersionId() : getTtsVersionIdForLocale(locale)"
                    [savedModel]="isRealtimeMode() ? activePrimarySnapshot() : getTtsSnapshotForLocale(locale)"
                    [defaultFirstMessage]="locale.first_message"
                    [languageId]="locale.language_id"
                    [localeId]="locale.locale_id"
                    [allowSelectFromTester]="true"
                    [currentAdditionalProperties]="getTtsValues(locale)"
                    [currentVoiceId]="isRealtimeMode() ? activePrimaryVoiceId() : getVoiceIdForLocale(locale)"
                    [includeAll]="modelsIncludeAll"
                    (includeAllChange)="onModelsIncludeAllChange($event)"
                    [label]="isRealtimeMode() ? selectRealtimeVoiceLabel : selectTtsModelLabel"
                    [snAssistantAnchor]="'voice.' + (getLanguageCodeForLocale(locale) || '')"
                    (modelSelected)="onTtsModelSelected(locale, $event)"
                    (testerSelected)="isRealtimeMode() ? onRealtimeVoiceTesterSelected(locale, $event) : onTtsTesterSelected(locale, $event)">
                  </app-model-selector-button>
                </div>
                <!-- Speech Rate Control -->
                <div class="locale-field">
                  <label class="locale-field-label" i18n="@@agentEdit.speechRate.label">Speech Rate</label>
                  <p class="locale-field-description" i18n="@@agentEdit.speechRate.description">Adjust the speed of speech. Default is 1.0 (normal speed).</p>
                  <div class="speech-rate-slider-container">
                    <label class="slider-label">
                      <ng-container i18n="@@agentEdit.speechRate.label">Speech Rate</ng-container>: {{ getSpeechRateForLocale(locale) }}
                    </label>
                    <p-slider
                      [ngModel]="getSpeechRateForLocale(locale)"
                      (ngModelChange)="setSpeechRateForLocale(locale, $event)"
                      [min]="0.5"
                      [max]="2.0"
                      [step]="0.1"
                      styleClass="w-full">
                    </p-slider>
                  </div>
                </div>
                <!-- Background Sound Type -->
                <div class="locale-field">
                  <label class="locale-field-label" i18n="@@agentEdit.bgSound.label">Background Sound</label>
                  <p class="locale-field-description" i18n="@@agentEdit.bgSound.description">Add ambient background sound to the conversation.</p>
                  <p-select
                    [options]="backgroundSoundTypeOptions"
                    [ngModel]="getBackgroundSoundTypeForLocale(locale)"
                    (ngModelChange)="setBackgroundSoundTypeForLocale(locale, $event)"
                    optionLabel="label"
                    optionValue="value"
                    i18n-placeholder="@@agentEdit.bgSound.placeholder"
                    placeholder="Select background sound"
                    styleClass="w-full">
                  </p-select>
                </div>
                <!-- Background Volume Control -->
                @if (getBackgroundSoundTypeForLocale(locale)) {
                  <div class="locale-field">
                    <label class="locale-field-label" i18n="@@agentEdit.bgVolume.label">Background Volume</label>
                    <p class="locale-field-description" i18n="@@agentEdit.bgVolume.description">Adjust the volume of background sound (0-100%).</p>
                    <div class="speech-rate-slider-container">
                      <label class="slider-label">
                        <ng-container i18n="@@agentEdit.bgVolume.short">Volume</ng-container>: {{ getBackgroundVolumeForLocale(locale) }}%
                      </label>
                      <p-slider
                        [ngModel]="getBackgroundVolumeForLocale(locale)"
                        (ngModelChange)="setBackgroundVolumeForLocale(locale, $event)"
                        [min]="0"
                        [max]="100"
                        [step]="5"
                        styleClass="w-full">
                      </p-slider>
                    </div>
                  </div>
                }
              </div>
            </p-card>
          }
        }
      </div>
    </div>
        </section>
        <section id="sec-transcriber" [hidden]="isRealtimeMode()">
    <div class="form-container">
      <!-- STT Model Section -->
      <div class="form-field">
        <label for="sttModel" class="field-label" i18n="@@agentEdit.stt.label">Speech-to-Text</label>
        <p class="field-description" i18n="@@agentEdit.stt.description">Choose the Speech-to-Text provider and specific model version for transcribing user speech.</p>
        <!-- Model Selection -->
        <div class="model-selection" style="width: 100%">
          <label for="sttModelVersion" class="sub-field-label" i18n="@@agentEdit.llm.modelVersion">Model Version</label>
          <app-model-selector-button
            [modelTypes]="['stt']"
            [modelsHierarchy]="modelsHierarchy"
            [includeVersionSnapshots]="sttSnapshots"
            [selectedVersionId]="sttVersionId"
            [savedModel]="sttSnapshot"
            [allowModelSelect]="true"
            [showVersions]="false"
            snAssistantAnchor="sttModelVersion"
            [allowSelectFromTester]="true"
            [currentAdditionalProperties]="getSttValues()"
            [languageId]="primaryLanguageId"
            [localeId]="primaryLocaleId"
            [includeAll]="modelsIncludeAll"
            (includeAllChange)="onModelsIncludeAllChange($event)"
            [label]="selectSttModelLabel"
            (modelSelected)="onSttModelSelected($event)"
            (testerSelected)="onSttTesterSelected($event)">
          </app-model-selector-button>
        </div>
      </div>
    </div>
        </section>
        <section id="sec-vad" [hidden]="isRealtimeMode()">
    <div class="form-container">
      <!-- VAD Configuration Section -->
      <div class="form-field">
        <label class="field-label" i18n="@@agentEdit.vad.label">Voice Activity Detection (VAD)</label>
        <p class="field-description" i18n="@@agentEdit.vad.description">Configure parameters for detecting when the user starts and stops speaking.</p>
        <!-- Model Selection -->
        <div class="model-selection" style="width: 100%">
          <label class="sub-field-label" i18n="@@agentEdit.vad.modelVersion">Model Version</label>
          <!-- Пороги распознавания речи: тонкая настройка, которую вслепую
               менять нельзя. -->
          <app-model-selector-button
            snAssistantSkip
            [modelTypes]="['vad']"
            [modelsHierarchy]="modelsHierarchy"
            [includeVersionSnapshots]="vadSnapshots"
            [selectedVersionId]="vadVersionId"
            [savedModel]="vadSnapshot"
            [allowModelSelect]="true"
            [showVersions]="false"
            [allowSelectFromTester]="true"
            [currentAdditionalProperties]="getVadValues()"
            [languageId]="primaryLanguageId"
            [localeId]="primaryLocaleId"
            [includeAll]="modelsIncludeAll"
            (includeAllChange)="onModelsIncludeAllChange($event)"
            [label]="selectVadModelLabel"
            (modelSelected)="onVadModelSelected($event)"
            (testerSelected)="onVadTesterSelected($event)">
          </app-model-selector-button>
        </div>
      </div>
    </div>
        </section>
        <section id="sec-widget"
                 [class.with-widget-preview]="showWidgetPreview()"
                 [class.reserve-for-preview]="showWidgetPreview() && !previewFitsAside()"
                 [style.--sn-preview-height]="previewHeightPx()">
    <div class="form-container">
      <!-- Publish Toggle Section -->
      <div class="form-field">
        <div class="switch-field">
          <div class="switch-content">
            <label class="switch-label" i18n="@@agentEdit.publish.label">Publish Agent</label>
            <p class="field-description" i18n="@@agentEdit.publish.description">Use the {{ appName }} widget to embed the agent on your website</p>
          </div>
          <p-toggleSwitch
            [snAssistantId]="F.isPublished"
            name="is_published"
            [(ngModel)]="agent()!.is_published"
            (ngModelChange)="onPublishToggleChange()">
          </p-toggleSwitch>
        </div>
      </div>
      <!-- Widget Configuration (shown only when published) -->
      @if (agent()!.is_published) {
        <!-- Embed Code Section -->
        <div class="form-field">
          <label class="field-label" i18n="@@agentEdit.embed.label">Embed code</label>
          <p class="field-description" i18n="@@agentEdit.embed.description">Add the following snippet to the pages where you want the conversation widget to be.</p>
          <p-inputgroup>
            <input
              pInputText
              [value]="getEmbedCode()"
              readonly
              class="embed-code-input">
            <p-inputgroup-addon>
              <p-button
                type="button"
                icon="pi pi-copy"
                severity="secondary"
                (click)="copyEmbedCode()"
                [pTooltip]="copyToClipboardTooltip"
                tooltipPosition="top"
                [ariaLabel]="copyToClipboardTooltip">
              </p-button>
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
        <!-- Public Agent URL Section -->
        <div class="form-field">
          <label class="field-label" i18n="@@agentEdit.publicUrl.label">Public agent URL</label>
          <p class="field-description" i18n="@@agentEdit.publicUrl.description">Direct link to interact with your published agent()!.</p>
          <p-inputgroup>
            <input
              pInputText
              [value]="getPublicAgentUrl()"
              readonly
              class="embed-code-input">
            <p-inputgroup-addon>
              <p-button
                type="button"
                icon="pi pi-copy"
                severity="secondary"
                (click)="copyPublicAgentUrl()"
                [pTooltip]="copyToClipboardTooltip"
                tooltipPosition="top"
                [ariaLabel]="copyToClipboardTooltip">
              </p-button>
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
        <!-- Appearance Section -->
        <div class="form-field">
          <label class="field-label" i18n="@@agentEdit.appearance.label">Appearance</label>
          <p class="field-description" i18n="@@agentEdit.appearance.description">Customize the widget to best fit your website.</p>
          <p-card>
            <!-- Variant Selection -->
            <div class="appearance-field">
              <label class="appearance-field-label" i18n="@@agentEdit.variant.label">Variant</label>
              <p-selectButton
                [snAssistantId]="F.appearance"
                [options]="widgetVariantOptions"
                name="appearance"
                [(ngModel)]="agent()!.public_agent!.publish_options!.appearance"
                (ngModelChange)="onPublishOptionsChange()"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full">
              </p-selectButton>
            </div>
            <!-- Placement Selection -->
            <div class="appearance-field">
              <label class="appearance-field-label" i18n="@@agentEdit.placement.label">Placement</label>
              <p-select
                [snAssistantId]="F.placement"
                [options]="widgetPlacementOptions"
                name="placement"
                [(ngModel)]="agent()!.public_agent!.publish_options!.placement"
                (ngModelChange)="onPublishOptionsChange()"
                optionLabel="label"
                optionValue="value"
                i18n-placeholder="@@agentEdit.placement.placeholder"
                placeholder="Select placement"
                styleClass="w-full">
              </p-select>
              <p class="field-description" style="margin-top: 0.5rem;" i18n="@@agentEdit.placement.note">The preview widget on this page updates its position as you change this setting — this is how it will appear on your website.</p>
            </div>
            <!-- Theme Selection — сохраняется в publish_options.theme. -->
            <div class="appearance-field">
              <label class="appearance-field-label" i18n="@@agentEdit.theme.label">Theme</label>
              <p-select
                [snAssistantId]="F.theme"
                [options]="widgetThemeOptions"
                name="theme"
                [(ngModel)]="agent()!.public_agent!.publish_options!.theme"
                (ngModelChange)="onPublishOptionsChange()"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full">
              </p-select>
              <p class="field-description" style="margin-top: 0.5rem;" i18n="@@agentEdit.theme.note">Light — standard, Dark — dark palette, Auto — follows the visitor's OS setting.</p>
            </div>
          </p-card>
        </div>
        <!-- Text Contents Section -->
        <div class="form-field">
          <label class="field-label" i18n="@@agentEdit.textContents.label">Text contents</label>
          <p class="field-description" i18n="@@agentEdit.textContents.description">Modify the text displayed in the widget.</p>
          <p-card>
            <!-- Main Label -->
            <div class="text-content-field">
              <label for="mainLabel" class="text-content-field-label">main_label</label>
              <input
                [snAssistantId]="F.mainLabel"
                pInputText
                inputId="mainLabel"
                name="main_label"
                [(ngModel)]="agent()!.public_agent!.publish_options!.main_label"
                (ngModelChange)="onPublishOptionsChange()"
                i18n-placeholder="@@agentEdit.mainLabel.placeholder"
                placeholder="Need help?"
                class="w-full"
                styleClass="w-full">
            </div>
            <!-- Button Label -->
            <div class="text-content-field">
              <label for="buttonLabel" class="text-content-field-label">button_label</label>
              <input
                [snAssistantId]="F.buttonLabel"
                pInputText
                inputId="buttonLabel"
                name="button_label"
                [(ngModel)]="agent()!.public_agent!.publish_options!.button_label"
                (ngModelChange)="onPublishOptionsChange()"
                i18n-placeholder="@@agentEdit.buttonLabel.placeholder"
                placeholder="Call us"
                class="w-full"
                styleClass="w-full">
            </div>
            <!-- End Call Button Label -->
            <div class="text-content-field">
              <label for="endCallButtonLabel" class="text-content-field-label">end_call_button_label</label>
              <input
                [snAssistantId]="F.endCallButtonLabel"
                pInputText
                inputId="endCallButtonLabel"
                name="end_call_button_label"
                [(ngModel)]="agent()!.public_agent!.publish_options!.end_call_button_label"
                (ngModelChange)="onPublishOptionsChange()"
                i18n-placeholder="@@agentEdit.endCallButtonLabel.placeholder"
                placeholder="End call"
                class="w-full"
                styleClass="w-full">
            </div>
          </p-card>
        </div>
        <!-- Interface Section -->
        <div class="form-field">
          <label class="field-label" i18n="@@agentEdit.interface.label">Interface</label>
          <p class="field-description" i18n="@@agentEdit.interface.description">Configure parts of the widget interface.</p>
          <p-card>
            <!-- Language Dropdown Toggle -->
            <div class="switch-field">
              <div class="switch-content">
                <label class="switch-label" i18n="@@agentEdit.langDropdown.label">Language dropdown</label>
                <p class="field-description" i18n="@@agentEdit.langDropdown.description">Allow users to switch between available languages in the widget interface</p>
              </div>
              <p-toggleSwitch
                [snAssistantId]="F.languageDropdown"
                name="language_dropdown"
                [(ngModel)]="agent()!.public_agent!.publish_options!.language_dropdown"
                (ngModelChange)="onPublishOptionsChange()">
              </p-toggleSwitch>
            </div>

            <!-- Show Transcript Toggle -->
            <div class="switch-field">
              <div class="switch-content">
                <label class="switch-label" i18n="@@agentEdit.showTranscript.label">Show transcript</label>
                <p class="field-description" i18n="@@agentEdit.showTranscript.description">Display live conversation transcript inside the widget during the call</p>
              </div>
              <p-toggleSwitch
                [snAssistantId]="F.showTranscript"
                name="show_transcript"
                [(ngModel)]="agent()!.public_agent!.publish_options!.show_transcript"
                (ngModelChange)="onPublishOptionsChange()">
              </p-toggleSwitch>
            </div>

            <!-- Allow Variables Input Toggle -->
            <div class="switch-field">
              <div class="switch-content">
                <label class="switch-label" i18n="@@agentEdit.allowVariablesInput.label">Allow variables input</label>
                <p class="field-description" i18n="@@agentEdit.allowVariablesInput.description">Before the call the visitor fills in agent variables (except system ones). Meaningful only if the agent has non-system variables declared.</p>
              </div>
              <p-toggleSwitch
                [snAssistantId]="F.allowVariablesInput"
                name="allow_variables_input"
                [(ngModel)]="agent()!.public_agent!.publish_options!.allow_variables_input"
                (ngModelChange)="onPublishOptionsChange()">
              </p-toggleSwitch>
            </div>
          </p-card>
        </div>
      }
    </div>
        </section>
      }
    </div>
}

<!-- Loading state -->
@if (!agent()) {
  <div class="loading-container">
    <p-progressSpinner class="loading-spinner"></p-progressSpinner>
    <p i18n="@@agentEdit.loading">Loading agent data...</p>
  </div>
}

<!-- Mobile Bottom Toolbar with PrimeNG -->
@if (agent()) {
  <p-toolbar class="mobile-bottom-toolbar">
    <ng-template pTemplate="start">
      <p-button
        type="button"
        i18n-label="@@common.back"
        label="Back"
        severity="secondary"
        [outlined]="true"
        (click)="goBack()"
        icon="pi pi-arrow-left"
        size="small">
      </p-button>
    </ng-template>

    <ng-template pTemplate="end">
      <p-button
        type="button"
        snAssistantAnchor="save"
        [label]="isSaving ? savingLabel : saveChangesLabel"
        (click)="saveAgent()"
        [severity]="activeTabIndex() === 'talk' ? 'primary' : 'secondary'"
        [icon]="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        [disabled]="isSaving"
        [loading]="isSaving"
        size="small">
      </p-button>
      @if (activeTabIndex() !== 'talk') {
        <p-button
          type="button"
          [label]="talkButtonLabel()"
          [ariaLabel]="talkToAgentLabel"
          icon="pi pi-play"
          severity="primary"
          size="small"
          [disabled]="isSaving"
          [styleClass]="agent()!.is_created_from_default ? 'pulse-glow' : ''"
          (click)="saveAndTestAgent()">
        </p-button>
      }
    </ng-template>
  </p-toolbar>
}

<!-- Webhook Tool Edit Drawer -->
<p-drawer
  [(visible)]="showWebhookDrawer"
  position="right"
  [modal]="true"
  [closeOnEscape]="true"
  [blockScroll]="false"
  styleClass="responsive-drawer webhook-tool-drawer"
  [style]="{ width: '800px' }">
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <i class="pi pi-bolt"></i>
      <span i18n="@@webhookTool.drawer.title">Webhook tool</span>
      <small class="drawer-subheader" i18n="@@webhookTool.drawer.subtitle">Configure a webhook tool to interact with external services.</small>
    </div>
  </ng-template>
  @if (showWebhookDrawer) {
    <app-webhook-tool
      [toolId]="selectedToolId"
      [agentTool]="selectedToolId ? getAgentTool(selectedToolId) : undefined"
      [isEmbedded]="true"
      (toolSaved)="onWebhookToolSaved($event)"
      (cancelled)="onWebhookToolCancelled()">
    </app-webhook-tool>
  }
  <ng-template pTemplate="footer">
    @if (webhookToolCmp(); as cmp) {
      <div class="tool-drawer-footer">
        <p-button
          type="button"
          i18n-label="@@common.back" label="Back"
          severity="secondary"
          [outlined]="true"
          icon="pi pi-arrow-left"
          (click)="cmp.onCancel()">
        </p-button>
        <div class="tool-drawer-footer-right">
          @if (cmp.isUpdateMode) {
            <p-button
              type="button"
              i18n-label="@@webhookTool.testTool" label="Test Tool"
              severity="secondary"
              [outlined]="true"
              icon="pi pi-play"
              [disabled]="cmp.isTestingTool"
              [loading]="cmp.isTestingTool"
              (click)="cmp.onTestTool()">
            </p-button>
          }
          <p-button
            type="button"
            [label]="cmp.saveChangesBtnLabel"
            [icon]="cmp.isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            [disabled]="cmp.isSaveDisabled"
            [loading]="cmp.isSaving"
            (click)="cmp.onSave()">
          </p-button>
        </div>
      </div>
    }
  </ng-template>
</p-drawer>

<!-- System Tool Edit Drawer -->
<p-drawer
  [(visible)]="showSystemToolDrawer"
  position="right"
  [modal]="true"
  [closeOnEscape]="true"
  [blockScroll]="false"
  styleClass="responsive-drawer system-tool-drawer"
  [style]="{ width: '600px' }">
  <ng-template pTemplate="header">
    @if (selectedSystemTool) {
      <div class="drawer-header">
        <i class="pi pi-cog"></i>
        <span>{{ systemToolTitle(selectedSystemTool) }}</span>
        <small class="drawer-subheader">{{ systemToolSummary(selectedSystemTool) }}</small>
      </div>
    }
  </ng-template>
  @if (showSystemToolDrawer && selectedSystemTool) {
    <app-system-tool
      [tool]="selectedSystemTool"
      [agentTool]="getAgentTool(selectedSystemTool.id || '')"
      [isEmbedded]="true"
      [availableAgents]="availableAgents"
      [defaultPhoneNumberAgentId]="agent()?.default_phone_number_agent_id ?? null"
      (defaultPhoneNumberAgentIdChange)="onDefaultPhoneNumberChange($event)"
      (toolSaved)="onSystemToolSaved($event)"
      (cancelled)="onSystemToolCancelled()">
    </app-system-tool>
  }
  <ng-template pTemplate="footer">
    @if (systemToolCmp(); as cmp) {
      <div class="tool-drawer-footer">
        <p-button
          snAssistantAction="tool.close"
          type="button"
          i18n-label="@@common.back" label="Back"
          severity="secondary"
          [outlined]="true"
          icon="pi pi-arrow-left"
          (click)="cmp.cancel()">
        </p-button>
        <p-button
          snAssistantAction="tool.apply"
          type="button"
          i18n-label="@@common.save" label="Save"
          icon="pi pi-check"
          (click)="cmp.save()">
        </p-button>
      </div>
    }
  </ng-template>
</p-drawer>
<!-- Превью виджета — РЕЖИМ ВИДЖЕТА: [widgetMode]="true", поэтому
     применяются appearance (Tiny/Compact/Full), placement, button_label
     и «Powered by» из publish_options. Это тот же AgentTestComponent из
     основного бандла: раньше здесь стоял <speaknode-agent> из отдельного
     app-widget, который поднимал в документе админки второй PrimeNG и
     затирал ей тему (SKN-425). Своему же компоненту ничего поднимать не
     надо. publicAgentOverride отдаёт live-настройки формы — превью
     реагирует на правки без сохранения. -->
@if (showWidgetPreview()) {
  <div class="widget-preview-container"
       #widgetPreview
       [class.is-above-actions]="!previewFitsAside()">
    <app-agent-test
      [agentId]="agent()!.id!"
      [publicAgentOverride]="publicAgentPreview()"
      [widgetMode]="true"
      [inheritPlatformTheme]="true"
      [showTranslatePicker]="false">
    </app-agent-test>
  </div>
}
</div>

<!-- Desktop Action Buttons (outside container for sticky positioning) -->
@if (agent()) {
  <div
    class="action-buttons"
    #actionButtons
    snAssistantSurface="agent"
    i18n-surfaceTitle="@@agentEdit.surface"
    surfaceTitle="Agent editor">
    <p-button
      type="button"
      i18n-label="@@common.back"
      label="Back"
      severity="secondary"
      [outlined]="true"
      (click)="goBack()"
      icon="pi pi-arrow-left">
    </p-button>
    <div class="action-buttons-right">
      <p-button
        type="button"
        snAssistantAnchor="save"
        [label]="isSaving ? savingLabel : saveChangesLabel"
        (click)="saveAgent()"
        [severity]="activeTabIndex() === 'talk' ? 'primary' : 'secondary'"
        [icon]="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        [disabled]="isSaving"
        [loading]="isSaving">
      </p-button>
      @if (activeTabIndex() !== 'talk') {
        <p-button
          type="button"
          i18n-label="@@agents.talk"
          label="Talk To Agent"
          icon="pi pi-play"
          severity="primary"
          [disabled]="isSaving"
          [styleClass]="agent()!.is_created_from_default ? 'pulse-glow' : ''"
          (click)="saveAndTestAgent()">
        </p-button>
      }
    </div>
  </div>
}

<!-- Delete Confirmation Dialog -->
<app-delete-confirmation
  [(visible)]="showDeleteConfirmation"
  [title]="deleteAgentTitle"
  [subtitle]="deleteAgentSubtitle"
  [deleting]="isDeletingAgent"
  (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()">
</app-delete-confirmation>